import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import type { ApiResponse } from "../../../types/apiResponse";
import type { billPayload } from "../types";
import fetchBills from "../api/fetchBills";
import withPrefix from "../../../helpers/useQueryPrefix";



export const useFetchBills = (): UseQueryResult<billPayload[], Error> => {
   return useQuery<
      ApiResponse<billPayload[]>,
      Error,
      billPayload[]
   >({
      queryKey: withPrefix(['bills']),
      queryFn: fetchBills,
      select: (response) => response.data ?? []
   })
}